import { render, staticRenderFns } from "./ContentHeader.vue?vue&type=template&id=0105f010&"
import script from "./ContentHeader.vue?vue&type=script&lang=js&"
export * from "./ContentHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContentHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports